import Vue from 'vue';

export default class EventBus {
  constructor() {
    this.bus = new Vue();

    this.on = this.bus.$on.bind(this.bus);
    this.off = this.bus.$off.bind(this.bus);
    this.emit = this.bus.$emit.bind(this.bus);
  }
}
